export default __webpack_public_path__ + "738e3c4aa8e9e67252aa5ddea3accf51.png";